import React, { useState, useEffect } from 'react';
import './Home.css';
import Navbar from './Navbar';
import About from './About';
import TentSolutions from './TentSolutions';
import LuxuryExperiences from './LuxuryExperiences';
import Process from './Process';
import Footer from './Footer';

const Home = () => {
  // Array of background images
  const backgroundImages = [
    '/images/heroImg.jpg',
    '/images/heroImg2.jpg',
    '/images/heroImg3.jpg',
  ];

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        (prevIndex + 1) % backgroundImages.length
      );
    }, 5000); // Change image every 5 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        {backgroundImages.map((image, index) => (
          <div
            key={index}
            className={`hero-background ${index === currentImageIndex ? 'active' : ''}`}
            style={{ backgroundImage: `url(${image})` }}
          />
        ))}
        <Navbar />
        <div className="hero-content">
          <h1>East Africa's Premier Tent Manufacturer</h1>
          <p>Crafting premium quality tents for events, safaris,<br />and commercial applications since 2010.</p>
        </div>
      </section>

      {/* About Section */}
      <About />

      {/* Tent Solutions Section */}
      <TentSolutions />

      {/* Luxury Experiences Section */}
      <LuxuryExperiences />

      {/* Process Section */}
      <Process />

     
    </div>
  );
};

export default Home; 